
export const publicFolder = (relativePath: string) => {
    return process.env.PUBLIC_URL + "/" + relativePath;
}

export default publicFolder;
